module.exports = __webpack_public_path__ + "static/rabbi-80968c9c18408d8de0ead20cfaa9bc4d.jpg";